<template>
  <div class="home">
    <Menu></Menu>
    <div v-show="showList">
    <h2>ACSW Members</h2>
    <MbrTbl :mem="mbrs" @beginFullEdit="toggleEditOn"/>
    </div>
    <MbrEdit2 :mbr="currMbr" v-show="fullEditInProcess" :may-edm-nbr="$hasRole(['adm','sys'])" @endFullEdit="toggleEditOff"></MbrEdit2>
  </div>
</template>

<script>
// @ is an alias to /src
import MbrTbl from '@/components/MbrTbl.vue'
import Menu from '@/components/Menu.vue'
import MbrEdit2 from '@/components/MbrEdit2.vue'
import router from "@/router";

export default {
  name: 'Members',
  components: {
    MbrTbl,
    Menu,
    MbrEdit2
  },
  mounted: function () {
    console.log('Members mounted')
    try {
      if (this.$usrStore.token == null) {
        if (localStorage.getItem('token') !== 'undefined') {
          if (localStorage.getItem('token').length > 4) {
            this.$initFromToken(localStorage.getItem('token'))
          }
        }
      }
    } catch (e) {
      alert("You are logged out. You will need to log in (again)")
      router.push('/')
    }
    this.loadMbrs()
    if(this.$itmStore.roles.length<1){
      this.loadRoles()
      console.log(this.$itmStore)
    }
    if(this.$itmStore.categories.length<1){
      this.loadCats()
      console.log(this.$itmStore)
    }
    if(!this.$itmStore.titles){
      this.loadTitles()
      console.log(this.$itmStore)
    }
    if(this.$itmStore.trialTypes.length < 1){
      this.loadTrialTypes()
      console.log(this.$itmStore)
    }
  },
  methods: {
    cloneItem: function (item) {
      return JSON.parse(JSON.stringify(item))
    },
    toggleEditOn: function (item) {
      console.log('You knocked...')
      console.log(item)
      this.fullEditInProcess = true
      this.editedIndex = this.mbrs.indexOf(item)
      this.currMbr = this.cloneItem(item)
    },
    toggleEditOff: function (item) {
      this.fullEditInProcess = false
      if(item) {
        console.log('You knocked...')
        console.log(item)
        this.mbrs.splice(this.editedIndex,1,item)
      }
    },
    loadMbrs: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/mbrs', {
        token: theToken
      })
          .then(response => {
            this.mbrs = response.data.mbrs
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                  this.$logOut()
                  this.router.push('/')
                  //window.location.assign('/members')
                } else {
                  alert(err)
                }
              }
          )
    },
    loadRoles: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/roles', {
        token: theToken
      })
          .then(response => {
            this.$itmStore.roles = response.data.roles
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadCats: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/mbrcats', {
        token: theToken
      })
          .then(response => {
            this.$itmStore.categories = response.data.categories
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadTitles: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/titles', {
        token: theToken
      })
          .then(response => {
            this.$itmStore.titles = {}
            for (let i=0; i< response.data.titles.length; i++) {
              let title = response.data.titles[i]
              let code = title.titleCode
              this.$itmStore.titles[code] = title
            }
            this.$itmStore.titleList = response.data.titles
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadTrialTypes: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api.trial/trialtypes', {
        token: theToken
      })
          .then(response => {
            this.$itmStore.trialTypes = response.data.trial_types
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
  },
  computed: {
    showList: function () {
      console.log("called showList()")
      if(this.fullEdit){
        return false
      }
      if (this.$usrStore.token) {
        return this.$hasRole(['adm','sys'])
      } else {
        return false
      }
    },
    fullEdit: function () {
      return this.fullEditInProcess
    }
  },
  data: () => ({
    loading: false,
    fullEditInProcess: false,
    currMbr: {},
    mbrs: [],
    editedIndex: -1,
  })
}
</script>
